import React from 'react';
import { Field, withFormik } from 'formik';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Yup from 'yup';
import { appTheme } from '../../../theme';
import {
  GridContainer,
  GridItem,
  StaticFormLayout,
  TextFieldWrapper,
} from '../../common';

const Instructions = styled.p`
  color: ${appTheme.system.title};
  margin: 0;
  padding: ${appTheme.spacing.default} 0;
  text-align: center;
`;

function ForgotPasswordForm({ status, values, ...rest }) {
  return status.hasSaved ? (
    <React.Fragment>
      <Instructions>Request Submitted</Instructions>
      <Instructions>
        Please check your email at <strong>{values.email}</strong> for
        information about resetting your password.
      </Instructions>
    </React.Fragment>
  ) : (
    <StaticFormLayout {...rest} submitButtonText="Send">
      <Instructions>
        Forgot your password?
        <br />
        No problem!
      </Instructions>
      <Instructions>
        Enter the email address you used to sign up and we'll send you a link to
        set up a new password.
      </Instructions>
      <GridContainer>
        <GridItem xs={12}>
          <Field
            component={TextFieldWrapper}
            id="email"
            label="Email"
            name="email"
          />
        </GridItem>
      </GridContainer>
    </StaticFormLayout>
  );
}

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,

  status: PropTypes.object,
};

ForgotPasswordForm.defaultProps = {
  status: {},
};

export default withFormik({
  displayName: 'ForgotPasswordForm',
  handleSubmit: (values, { props, setStatus, setSubmitting }) => {
    return props
      .onSubmit({ email: values.email })
      .then(() => setStatus({ hasSaved: true }))
      .catch(error => {
        setStatus({ saveError: error });
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
  mapPropsToValues: () => ({
    email: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Please enter a valid email address.')
      .required('Email address is required.'),
  }),
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/modules/ForgotPasswordPage/components/ForgotPasswordForm.js